module.exports = __webpack_public_path__ + "static/media/S1N10-1.cf0898a3.svg";